import { VizType } from "@atlas-int/data";
import { ReactElement } from "react";
import { YearSelectionRole } from "@atlas-int/controls";
import YearDropdown from "../yearDropdown/YearDropdown";
import { ControlRow } from "@atlas-int/ui";

interface YearInputsProps {
  vizType: VizType;
  useYearRange?: boolean;
}

export const YearInputs = ({
  vizType,
  useYearRange,
}: YearInputsProps): ReactElement => {
  const shouldUseYearRange =
    useYearRange ??
    (vizType === VizType.OverTime || vizType === VizType.MarketShare);

  if (shouldUseYearRange) {
    return (
      <>
        <ControlRow label="Start Year" inputWidth="70px">
          <YearDropdown yearSelectionRole={YearSelectionRole.StartYear} />
        </ControlRow>
        <ControlRow label="End Year" inputWidth="70px">
          <YearDropdown yearSelectionRole={YearSelectionRole.EndYear} />
        </ControlRow>
      </>
    );
  }

  return (
    <ControlRow label="Year" inputWidth="70px">
      <YearDropdown yearSelectionRole={YearSelectionRole.FixedYear} />
    </ControlRow>
  );
};
